<template>
  <div>
    <div
      class="tw-opacity-95 tw-fixed tw-top-0 tw-left-0 tw-h-screen tw-w-screen bgCustom"
      style="z-index: 9998"
    ></div>
    <div
      class="tw-fixed tw-top-0 tw-left-0 tw-h-screen tw-w-screen tw-flex tw-flex-col tw-text-white tw-text-center"
      style="z-index: 9999"
    >
      <div
        class="tw-flex-1 tw-flex tw-font-normal tw-text-center tw-justify-center tw-items-end"
      >
        <slot name="header" />
      </div>
      <div class="tw-flex-1 tw-flex tw-justify-center tw-items-start">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.bgCustom {
  background: linear-gradient(
    162.73deg,
    rgba(140, 38, 103, 0.9) 0%,
    rgba(82, 8, 55, 0.9) 101.37%
  );
  backdrop-filter: blur(16px);
}
</style>
